import _ from 'lodash';
import styles from './katexRenderToString.module.scss';

const loadKatex = _.once(async () => {
  const [katex] = await Promise.all([
    import('katex'),
    // @ts-expect-error No typings for styles
    import('katex/dist/katex.css'),
  ]);
  return katex.default;
});

const katexRenderToString = async (code: string) => {
  const katex = await loadKatex();
  const html = katex.renderToString(code, {
    throwOnError: true,
    displayMode: true,
    output: 'html',
  });
  return `<div class="${styles.container}">${html}</div>`;
};

export default katexRenderToString;
